export function normalizeCategoryLabel(value) {
    return typeof value === 'string' ? value.trim().toLowerCase() : ''
}

export function resolveCategoryLabel(item) {
    const rawLabel = typeof item?.category === 'string' ? item.category.trim() : ''
    if (rawLabel) {
        return rawLabel
    }
    return item?.searchType === 'places' ? 'Place' : 'Event'
}

export function buildCategoryKey(type, label) {
    const normalizedType = type === 'places' ? 'places' : 'events'
    const normalizedLabel = normalizeCategoryLabel(label)
    return `${normalizedType}:${normalizedLabel}`
}

export function deriveCategoryKeyFromItem(item) {
    const type = item?.searchType === 'places' ? 'places' : 'events'
    const label = resolveCategoryLabel(item)
    return buildCategoryKey(type, label)
}

export function buildCategoryOptions(results) {
    const unique = new Map()
    results.forEach(item => {
        const type = item?.searchType === 'places' ? 'places' : 'events'
        const label = resolveCategoryLabel(item)
        const key = buildCategoryKey(type, label)
        if (!unique.has(key)) {
            unique.set(key, { key, label, type })
        }
    })
    const sortOrder = { events: 0, places: 1 }
    return Array.from(unique.values()).sort((a, b) => {
        const typeDiff = (sortOrder[a.type] ?? 0) - (sortOrder[b.type] ?? 0)
        if (typeDiff !== 0) {
            return typeDiff
        }
        return a.label.localeCompare(b.label, undefined, { sensitivity: 'base' })
    })
}
